import { Inject, Injectable } from '@angular/core';

declare const window: any;

@Injectable()
export class CheckoutService {
  private readonly RETRY_DELAY_MS: number = 5000;
  private readonly urlParams: string = window.location.search;
  private counter: number = window.CHECKOUT_SUBMIT_TIMEOUT / (this.RETRY_DELAY_MS / 1000);

  constructor( @Inject('Endpoint') private endpoint: any) {}

  public controlOrderProgress(): void {
    this.startTimer();
  }

  public isRedirection(result: any): boolean {
    return result.body.hasOwnProperty('url') && (result.status === 302 || result.status === 412);
  }

  private showErrorPage(): void {
    window.location.replace('/cart/multi/error/orderValidationError' + this.urlParams);
  }

  private startTimer(): void {
    setInterval(() => {
      if (this.counter === 0) {
        this.showErrorPage();

        return;
      }

      this.counter--;
      this.endpoint('restOrder.orderProgressInfo')
      .run()
      .then(
        (response: any) => {
          const body = response.body;

          if (body.hasOwnProperty('url')) {
            window.location.replace(body.url);
            return;
          }

          if (body.hasCrmdOrderId) {
            this.showSummaryPage();
          }
        })
        .catch(() => {
          this.showErrorPage();
        });
    }, this.RETRY_DELAY_MS);
  }

  private showSummaryPage(): void {
    window.location.replace('/cart/checkout4' + this.urlParams);
  }
}


